<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" style="margin-top: 3em;"><a href="#/toc#mon518" id="sun518">LONDON<br/>1944</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// london.vue?3df70eda